/** Online-now presence: stable anonymous id + heartbeat. No PII, no cookies. */

export const PRESENCE_KEY = "gmh_pid";
export const PRESENCE_HEARTBEAT_MS = 30_000;

/** Get or create a stable anonymous presence id for this browser. */
export function getPresenceId(storage = (typeof window !== "undefined" ? window.localStorage : null)) {
  try {
    if (!storage) return null;
    let id = storage.getItem(PRESENCE_KEY);
    if (!id) {
      id = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `p_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
      storage.setItem(PRESENCE_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

/**
 * Start a heartbeat that POSTs presence every `intervalMs`. Returns a stop fn.
 * `beat` is called with the id and should return a promise resolving to the
 * parsed body ({ online }) — failures are swallowed (presence is best-effort).
 */
export function startPresenceHeartbeat({ beat, intervalMs = PRESENCE_HEARTBEAT_MS, onCount, storage } = {}) {
  const id = getPresenceId(storage);
  if (!id || typeof beat !== "function") return () => {};
  let stopped = false;
  let timer = null;

  const tick = async () => {
    if (stopped) return;
    try {
      const body = await beat(id);
      if (!stopped && body && typeof onCount === "function") {
        const n = Number(body.online);
        if (!Number.isNaN(n)) onCount(n);
      }
    } catch {
      /* asleep / offline — leave last count; UI decides whether to show */
    }
    if (!stopped) timer = setTimeout(tick, intervalMs);
  };

  tick();
  return () => { stopped = true; if (timer) clearTimeout(timer); };
}
